import { createAsyncThunk } from "@reduxjs/toolkit";
import phonenumbers from "@/lib/api/phonenumbers";
import { IUserSlice } from "@/redux/slices/user/types";

export const getUserVoip = createAsyncThunk(
  "user/getUserVoip",
  async () => await phonenumbers.hasVoip().then((r) => r.data)
);

const fulfilled = (state: IUserSlice, { payload }) => {
  state.user.voip = payload;
};

export default {
  action: getUserVoip,
  fulfilled,
};
